"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.definitionWithWarehousing = exports.isBeingWarehoused = exports.getWarehousingFeature = void 0;
var getWarehousingFeature = function (features) {
    return features.warehousing;
};
exports.getWarehousingFeature = getWarehousingFeature;
// With the initial release of snapshotting/warehousing, we know whether a metric is being snapshotted
// by the presence of the `warehousing` feature, which, for now, will always be { aggregation: "last" }.
// See details here: https://salesforce.quip.com/IE4KAd1EBEvb#temp:C:CFb2250dce89837428184f4d4352
var isBeingWarehoused = function (features) {
    return !!features && features.warehousing !== undefined;
};
exports.isBeingWarehoused = isBeingWarehoused;
var definitionWithWarehousing = function (definition) {
    var newFeatures = __assign(__assign({}, definition.features), { warehousing: { aggregation: 'last' } });
    return __assign(__assign({}, definition), { features: newFeatures });
};
exports.definitionWithWarehousing = definitionWithWarehousing;
//# sourceMappingURL=index.js.map